import React, { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import { Card, CardBody, Col, Form } from "reactstrap";
import { MultiImageUpload, MultipleImageVideoAudioUpload } from "../../../Constant";
import CommonFileUpload from "../../Common/CommonFileUpload";
import HeaderCard from "../../Common/HeaderCard";

const Multipledropzone = () => {
  return (
    <Fragment>
      <Col sm="12">
        <Card>
          <HeaderCard title={MultiImageUpload} />
          <CardBody>
            <Form>
              <ToastContainer />
              <div className="dz-message needsclick">
                <CommonFileUpload multiple />
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
      <Col sm="12">
        <Card>
          <HeaderCard title={MultipleImageVideoAudioUpload} />
          <CardBody>
            <Form>
              <div className="dz-message needsclick">
                <CommonFileUpload multiple />
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default Multipledropzone;
